import React, { ReactNode, useState } from "react";
import type Stitches from "@stitches/react";
import {
  ActionBanner as ActionBannerStyledComponent,
  BannerActions,
} from "./__styles__/ActionBanner";
import { BANNER_TYPES } from "./__styles__/Banner";
import { BannerItem } from "./Banner";
import { Button } from "./Button";
import { Icon } from "./Icons/LucideIcons";

export interface ActionBannerProps
  extends Stitches.VariantProps<typeof ActionBannerStyledComponent> {
  children?: ReactNode;
  loading?: boolean;
  type?: BANNER_TYPES;
  downloadButtonUrl?: string;
  downloadButtonText?: string;
  dismissButton?: boolean;
  onDismiss?: () => void;
}

const ActionBanner = ({
  children,
  type = BANNER_TYPES.INFO,
  loading,
  downloadButtonUrl,
  downloadButtonText = "Download",
  dismissButton,
  onDismiss,
}: ActionBannerProps) => {
  const [isHidden, setIsHidden] = useState(false);

  const handleDismiss = () => {
    setIsHidden(true);
    onDismiss?.();
  };

  if (isHidden) {
    return null;
  }

  return (
    <ActionBannerStyledComponent type={type}>
      <BannerItem loading={loading} type={type}>
        {children}
      </BannerItem>

      <BannerActions>
        {downloadButtonUrl && (
          <Button
            size="small"
            styleVariant="secondary"
            onClick={() => window.open(downloadButtonUrl, "_blank")}
          >
            {downloadButtonText}
          </Button>
        )}

        {dismissButton && (
          <Icon
            iconName="x"
            color="contentPrimary"
            size={16}
            onClick={handleDismiss}
            aria-label="Dismiss"
          />
        )}
      </BannerActions>
    </ActionBannerStyledComponent>
  );
};

export default ActionBanner;
